import {LineupsMemberSuspensionApiModel} from "./lineups-member-suspension-api-model";
import {BaseDomainModel} from "../../../../../infrastructure/models/base-domain-model";

export class LineupsMemberSuspensionDomainModel extends BaseDomainModel {
  apiModel: LineupsMemberSuspensionApiModel;

  get name(): String{
    return this.apiModel.name;
  }
}
